module.exports = __WEBPACK_EXTERNAL_MODULE_40__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 40
// module chunks = 0 1